module.exports = __webpack_public_path__ + "img/Autocolant VVHE_150mm x 180mm-01.a1921dc0.jpg";